import type { Cue } from '@core/model/cue.ts';

function secondsToSrtTime(totalSeconds: number): string {
  if (typeof totalSeconds !== 'number' || Number.isNaN(totalSeconds) || totalSeconds < 0) {
    return '00:00:00,000';
  }
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const milliseconds = Math.round((totalSeconds - Math.floor(totalSeconds)) * 1000);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')},${String(milliseconds).padStart(3, '0')}`;
}

/** Encode cues to SRT (cue start/end in milliseconds — extension parity). */
export function encodeSrt(cues: Array<Pick<Cue, 'start' | 'end' | 'text'>>): string {
  let result = '';
  for (let i = 0; i < cues.length; i += 1) {
    const cue = cues[i];
    if (!cue) continue;
    result += `${i + 1}\n`;
    result += `${secondsToSrtTime(cue.start / 1000)} --> ${secondsToSrtTime(cue.end / 1000)}\n`;
    result += (cue.text ?? '').trim();
    if (i < cues.length - 1) result += '\n\n';
  }
  return result;
}

export function downloadTextFile(filename: string, text: string): void {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function buildSrtFilename(
  videoId: string,
  _slot: 'main' | 'second',
  languageCode?: string,
): string {
  const vid = String(videoId || 'subtitle')
    .trim()
    .replace(/[^\w.-]+/g, '_')
    .replace(/^_+|_+$/g, '') || 'subtitle';
  const safe = String(languageCode ?? '')
    .trim()
    .replace(/[^\w.-]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return safe ? `${vid}.${safe}.srt` : `${vid}.srt`;
}
